import { browserHistory } from 'react-router';
import ActionType from './types';
import store from '../store/configureStore';
import { getCentroidForSpot, parkingSpotsGroupedBy } from '../utils';
import {SHOW_PARKING_SPOTS_ZOOM_LEVEL} from './../constants';

export const selectSpot = (spotIdentifier) => {
  return (dispatch, getState) => {
    const state = getState();
    if(state.parkingSpots.selectedPointsOfInterest){
      dispatch({
        type: ActionType.RESET_SELECTED_POINT_OF_INTEREST
      });
    }
    dispatch({
      type: ActionType.SELECT_PARKING_SPOT,
      selectedSpot: spotIdentifier
    });
    addSpotIdInUrl(spotIdentifier);
  };
};

export const addSpotIdInUrl = (spotIdentifier) => {
  browserHistory.push(`/parking/${spotIdentifier}`);
};

export const resetSelectedSpot = () => {
  return (dispatch, getState) => {
    dispatch({
      type: ActionType.RESET_SELECTED_SPOT
    });
    browserHistory.push(`/parking`);
  };
};

export const selectPointsOfInterest = (selectedPointsOfInterest) => {
  return (dispatch, getState) => {
    const state = getState();
    if(state.parkingSpots.selectedSpot) {
      dispatch(resetSelectedSpot());
    }
    dispatch({
      type: ActionType.SELECT_POINT_OF_INTEREST,
      selectedPointsOfInterest
    });
  };
};

export const onParkingSpotClick = (properties) => {
  return (dispatch) => {
    dispatch(selectSpot(properties.spotid));
  };
};

export const onPointsOfInterestClick = (properties) => {
  return (dispatch) => {
    dispatch(selectPointsOfInterest(properties));
  };
};

export const updateParkingSpots = (data) => {
  return (dispatch, getState) => {
    if(data){
      const processedSpotsList = getProcessedSpotsList(data || {});
      dispatch({
        type: ActionType.UPDATE_PARKING_SPOT_INFOS,
        data: processedSpotsList,
      });

      const currentState = getState();
      const { heldSpot } = currentState.userAccommodationInfo;
      if(heldSpot && processedSpotsList.hasOwnProperty(heldSpot)){
        dispatch(checkIsBackendReleasedHeldSpot(heldSpot));
      }
    }
  };
};

export const checkIsBackendReleasedHeldSpot = (heldSpot) => {
  return (dispatch, getState) => {
    const currentState = getState();
    const { list } = currentState.parkingSpots;
    const spot = list[heldSpot];
    if(spot.status === 'OPEN') {
      dispatch({
        type: ActionType.RESET_HELD_SPOTS
      });
      dispatch({
        type: ActionType.TOGGLE_BACKEND_RELASE_SPOT_FLAG,
        isBackendRelasedSpot: true
      });
    }
  };
};

export const zoomToSpot = (spotId, zoomLevel = SHOW_PARKING_SPOTS_ZOOM_LEVEL) => {
  const centroid = getCentroidForSpot(spotId);

  return (dispatch) => {
    dispatch(zoomByCoordinates(centroid, zoomLevel));
  };
};

export const zoomByCoordinates = ({lat, lng}, zoomLevel = SHOW_PARKING_SPOTS_ZOOM_LEVEL) => {
  return (dispatch) => {
    dispatch({
      type: ActionType.MAP_SET_GEOGRAPHY,
      position: [lat, lng],
      zoomLevel
    });
  };
};

export const groupParkingSpotsByFeaturesIfRequired = () => {
  const {groupedParkingSpots} = store.getState().parkingSpots;

  return (dispatch) => {
    if(! (groupedParkingSpots['sizes'] && groupedParkingSpots['surface'])){
      const spotsGroupedBySurface = parkingSpotsGroupedBy('surface');
      const spotsGroupedBySize = parkingSpotsGroupedBy('size');

      dispatch({
        type: ActionType.SET_GROUPED_PARKING_SPOTS,
        groupedParkingSpots: { sizes: spotsGroupedBySize, surface: spotsGroupedBySurface }
      });
    }
  };
};

export const getProcessedSpotsList = (list) => {
  // We are not using lastUpdate & checksum key.
  // Deleteing these key from saving in localstorage.
  for(let spotId in list) {
    const item = list[spotId];
    delete item.lastUpdate;
    delete item.checksum;
  }

  return list;
};



// WEBPACK FOOTER //
// ./src/actions/parkingSpots.js